import { formatSupportUnreadCount, supportUnreadLabel } from "@/lib/support/unread";

export default function SupportUnreadBadge({ count, className = "" }: { count: number; className?: string }) {
  if (count <= 0) return null;
  return (
    <span
      aria-label={supportUnreadLabel(count)}
      className={`inline-flex min-w-5 shrink-0 items-center justify-center rounded-full bg-rose-500 px-1.5 py-0.5 text-[10px] font-semibold leading-4 !text-white ${className}`}
    >
      {formatSupportUnreadCount(count)}
    </span>
  );
}
